import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Card,
    CardContent,
    Grid,
    Modal,
    TablePagination,
    MenuItem,
    Menu,
    IconButton,
    Radio, 
    RadioGroup, 
    FormControlLabel, 
    FormControl, 
    FormLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputAdornment
  } from "@mui/material";
import { checkLoanEligibility, commonRunQuery, loanPayment } from "../../util/API/loans";
import "./LoanPaymentView.scss";
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import LoanPaymentBreakdown from "../LoanPaymentBreakdown/LoanPaymentBreakdown";
import SearchIcon from "@mui/icons-material/Search";
import LoanPaymentDetails from "../LoanPaymentDetails/LoanPaymentDetails";
import CloseIcon from "@mui/icons-material/Close";

const LoanPaymentView = ({setViewPayments, setIsLoading, selectedProductLoan, selectedUser}) => {
    const [loanData, setLoanData] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [selectedLoanType, setSelectedLoanType] = useState(null);
    const [customAmount, setCustomAmount] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: ''
    });
    const [userPayments, setUserPayments] = useState([]);
    const [allUserPayments, setAllUserPayments] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [paymentType, setPaymentType] = useState("full");
    const [isGlobalPayment, setIsGlobalPayment] = useState(false);
    const [openLoanDetailsDrawer, setOpenLoanDetailsDrawer] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    
    // Dummy Data to send to api
    // const [sampleloantype, setSampleloantype] = useState(1);
    // const [sampleloanamount, setSampleloanamount] = useState(1);
    // const [sampleloanamountforfeecalculation, setSampleloanamountforfeecalculation] = useState(1);
    // const [sampletermtype, setSampletermtype] = useState(0);
    // const [refid, setRefid] = useState(1);
    // const [returnoutstandingloans, setReturnoutstandingloans] = useState(1);
    // const [intent, setIntent] = useState("");
    // =====================================================  //

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        //   backgroundColor: 'rgba(0,0,0, .1)',
          color: theme.palette.common.black,
          fontWeight: 'bold',
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 25,
          fontWeight: '600'
        },
    }));

    useEffect(()=> {
        console.log("paymentSelectedProductLoan============",selectedProductLoan);
        getUserPayments()
    },[selectedProductLoan])

    const getUserPayments = async() => {
        try {
            // let response = await checkLoanEligibility(
            //     "",
            //     selectedUser,
            //     selectedProductLoan?.productcode,
            //     sampleloantype,
            //     sampleloanamount,
            //     sampleloanamountforfeecalculation,
            //     sampletermtype,
            //     refid,
            //     returnoutstandingloans,
            //     intent
            // );

            let response = await commonRunQuery("235", selectedUser);

            console.log("getUserPayments_loanProductsArray============",response);

            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanProductsArray = Array.isArray(response?.data?.body?.record)
                  ? response?.data?.body?.record
                  : [response?.data?.body?.record];
                console.log("getUserPayments_loanProductsArray============",loanProductsArray);
                setLoanData(response?.data);
                setUserPayments(loanProductsArray);
                setAllUserPayments(loanProductsArray);
            } else {
                setUserPayments([]);
                setAllUserPayments([]);
                setLoanData(response?.data);
            }
        } catch (error) {
            console.log("getUserPayments_error============",error);
        } 
    }

    // const handlePayment = async(loan, type) => {
    //     try {
    //         const amount = type === "full" ? loan?.outstandingamountwithlatefee : loan?.outstandinglatefees;
    //         const latefeesonly = type === "full" ? 0 : 1;
    //         const response = await loanPayment("", selectedUser, selectedProductLoan?.productcode, amount, 1, 0, loan?.loanid, latefeesonly, "");
    //         console.log("handlePayment_response============",response);
    //         if(response?.data?.header?.callStatus == "1") {
    //             setIsLoading(false)
    //             setAlert({
    //                 showAlert: true,
    //                 severity: "success",
    //                 message: "Loan amount paid successfully.",
    //                 header: "Congratulations!"
    //             });

    //             setSelectedLoan(null);
    //             getUserPayments();
    //         }
    //     } catch (error) {
    //         console.log("handlePayment_error============",error);
    //     }
    // }

    // Submit custom payment
    
    const handleCustomPayment = async() => {
        try {
            const latefeesonly = paymentType === "late" ? 1 : 0;
            console.log("selectedLoan============",selectedLoan);
            console.log("customAmount============",customAmount);
            console.log("selectedLoan?.loanid============",selectedLoan?.loanid);
            console.log("latefeesonly============",latefeesonly);
            // console.log(`Pay Custom Amount: ${customAmount} for Loan ID: ${selectedLoan.loanid}`);
            const response = await loanPayment("", selectedUser, selectedProductLoan?.productcode, customAmount, 1, 0, selectedLoan ? selectedLoan?.loanid : 0, latefeesonly, "");
            console.log("handleCustomPayment_response============",response);
            if(response?.data?.header?.callStatus === "1") {
                setIsLoading(false)
                setAlert({
                    showAlert: true,
                    severity: "success",
                    message: "Loan amount paid successfully.",
                    header: "Congratulations!"
                });
                
                setPaymentType("full");
                setSelectedLoan(null);
                getUserPayments();
            }

            setOpenModal(false);
            setCustomAmount("");
        } catch (error) {
            console.log("handleCustomPayment_error============",error);
        }
    };

    // const handlePaymentConfirmation = (type, loan) => {
    //     if (type === "custom") {
    //         console.log("handlePaymentConfirmation---------------------",loan)
    //         setSelectedLoan(loan);
    //         setSelectedLoanType(loan);
    //         setOpenModal(true);
    //     } else {
    //         setAlert({
    //             ...alert,
    //             showAlert: true,
    //             message: `Are you sure you want to ${type === "full" ? "Pay Full Amount" : "Pay Only Late Fees"}`,
    //             severity: "confirm",
    //             header: "Please Confirm",
    //             alertType: 'confirm',
    //             onConfirm: () => {
    //                 handlePayment(loan, type);
    //             },
    //             // onConfirm: () => handlePayment(loan)
    //           })
    //         console.log(type === "full" ? "Pay Full Amount" : "Pay Only Late Fees", loan);
    //     }
    // };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
        setCustomAmount("");
        setPaymentType("full");
    };
    
    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
        // setSelectedLoan(null);
    };

    const handleModalRadioBtnChange = async(e) => {
        setPaymentType(e.target.value)
        console.log("handleModalRadioBtnChange_e------------",e.target.value)
        if(isGlobalPayment === true) {
            if(e.target.value === "full") {
                setCustomAmount(totalOutstandingAmount);
            } else {
                setCustomAmount(totalLateFees);
            }
        } else {
            if(e.target.value === "full") {
                setCustomAmount(selectedLoan?.outstandingamountwithlatefee);
            } else {
                setCustomAmount(selectedLoan?.outstandinglatefees);
            }
        }
    }
    
    const handleGlobalPayment = () => {
        try {
            setSelectedLoan(null);
            setIsGlobalPayment(true);
            setOpenModal(true);
            setCustomAmount(totalOutstandingAmount);
        } catch (error) {
            
        }
    }

    const handleSingleLoanPayment = async(loan) => {
        setSelectedLoan(loan)
        setPaymentType("full");
        setIsGlobalPayment(false);
        setCustomAmount(loan?.outstandingamountwithlatefee);
        setOpenModal(true);
    }

    const handlePaymentBreakdown = async() => {
        console.log("handlePaymentBreakdown-------------",selectedLoan)
        // setSelectedLoan(loan)
        setOpenLoanDetailsDrawer(true);
    }

    const handleSearch = async() => {
        if (!searchText.trim()) {
            setUserPayments(allUserPayments); // Reset to original data if search is cleared
            return;
        }
        const filteredLoans = allUserPayments.filter((row) => {
            console.log("filteredLoans_row----------",row?.loanpayments?.currcode)
            console.log("filteredLoans_row----------",row?.loanpayments?.currcode)
            return (
                row?.loanpayments?.currcode.includes(searchText.toUpperCase()) ||
                row?.loanpayments?.loanid?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanpayments?.paymentid?.toString().includes(searchText) ||
                row?.loanpayments?.amountapplied?.toString().includes(searchText) ||
                row?.loanpayments?.latefeesamountapplied?.toString().includes(searchText) ||
                row?.loanpayments?.principleamountapplied?.toString().includes(searchText) ||
                row?.loanpayments?.residualamount?.toString().includes(searchText) ||
                row?.loanpayments?.paymentdate?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
        console.log("filteredLoans----------",filteredLoans)
        setUserPayments(filteredLoans);
    }

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    const handleViewDetails = (loan) => {
        setSelectedLoan(loan);
        // setOpenDetailsDialog(true);
        setOpenDetailsDrawer(true);
        handleMenuClose(); // close the menu
    };

    const totalOutstandingAmount = userPayments.reduce(
        (sum, loan) => sum + parseFloat(loan.outstandingamountwithlatefee), 0
    );
    const totalLateFees = userPayments.reduce(
        (sum, loan) => sum + parseFloat(loan.outstandinglatefees), 0
    );
    const totalAmountPaid = userPayments.reduce(
        (sum, loan) => sum + parseFloat(loan.totalprinciplepaid), 0
    );
    const totalamountapplied = userPayments.reduce(
        (sum, loan) => sum + parseFloat(loan?.loanpayments?.amountapplied), 0
    );

    const formatAmount = (val) => val ? Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-';

    return (
        <Box className="loan-payment-container">
            <Box className="d-flex justify-content-between">
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                >
                    User Payments
                </Typography>
                <Box>
                <Button
                    className="fs-size-12 paiy-blue text-white"
                    variant="contained"
                    color="primary"
                    onClick={() => setViewPayments(false)}
                >
                    Return
                </Button>
                </Box>
            </Box>

            <Box>
                {/* <Box sx={{ flexShrink: 0, justifyContent:"center" }} className="mt-4">
                    <Grid container spacing={1}>
                    {[
                        { label: "Total Amount Applied", value: totalamountapplied.toFixed(2) },
                        { label: "Total Outstanding Amount", value: totalOutstandingAmount.toFixed(2) },
                        { label: "Total Principal Paid", value: totalAmountPaid.toFixed(2) },
                        { label: "Total Late Fees", value: totalLateFees.toFixed(2) },
                    ].map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Box
                                sx={{
                                    padding: "6px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    backgroundColor: "#f9f9f9",
                                }}
                            >
                                <Typography variant="caption" sx={{ fontWeight: "bold", fontSize:"14px" }}>
                                {item.label}
                                </Typography>
                                <Typography variant="body1" sx={{ fontSize:"14px" }}>{item.value}</Typography>
                            </Box>
                        </Grid>
                    ))}
                    </Grid>
                </Box> */}

                <Box className="mt-4">
                    <Box className="search-container">
                        <TextField
                            placeholder="Search amount, late fees, etc."
                            value={searchText}
                            onChange={handleInputChange}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    handleSearch(); 
                                }
                            }}
                            variant="standard"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                                sx: {
                                    borderRadius: "33px",
                                    color: "#000",
                                },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleSearch} edge="end">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                "& .MuiInputBase-root": {},
                                "& .MuiInputBase-input": {
                                    fontSize: "14px",
                                },
                            }}
                        />
                    </Box>
                </Box>

                {/* Pay All Loans Section */}
                {/* {outstandingLoans?.length > 0 && (
                    <Box mt={3} textAlign="center">
                        <Typography variant="h6">Make Payment for All Loans</Typography>
                        <TextField
                            type="number"
                            fullWidth
                            placeholder="Enter total payment amount"
                            size="small"
                            sx={{ my: 2, maxWidth: 300 }}
                        />
                        <Box>
                            <Button variant="contained" color="primary" sx={{ mx: 1 }}>
                            Pay Full Amount
                            </Button>
                            <Button variant="contained" color="secondary" sx={{ mx: 1 }}>
                            Pay Late Fees
                            </Button>
                        </Box>
                    </Box>
                )} */}
            </Box>

            <Box className="mt-4">
                <TableContainer sx={{ marginTop: 2 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center">Currency Code</StyledTableCell>
                                <StyledTableCell align="center">Loan Id</StyledTableCell>
                                <StyledTableCell align="center">Payment Id</StyledTableCell>
                                <StyledTableCell align="center">Payment Date</StyledTableCell>
                                {/* <StyledTableCell>Payment Amount</StyledTableCell> */}
                                <StyledTableCell align="right" >Amount Applied</StyledTableCell>
                                <StyledTableCell align="right" >Late Fees Amount Applied</StyledTableCell>
                                <StyledTableCell align="right" >Principle Amount Applied</StyledTableCell>
                                <StyledTableCell align="right" >Residual Amount</StyledTableCell>
                                <StyledTableCell align="center">Action</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {userPayments?.length > 0 ? userPayments?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((loan, idx) => (
                                <TableRow key={idx}>
                                    <TableCell className="payments-table-headers">
                                        {loan?.loanpayments?.currcode}
                                    </TableCell>
                                    <TableCell className="payments-table-headers">
                                        {loan?.loanpayments?.loanid}
                                    </TableCell>
                                    <TableCell className="payments-table-headers">
                                        {loan?.loanpayments?.paymentid}
                                    </TableCell>
                                    <TableCell className="payments-table-headers">
                                        {loan?.loanpayments?.paymentdate}
                                    </TableCell>
                                    {/* <TableCell className="payments-table-headers">
                                        {Number(loan?.loanpayments?.paymentamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                    </TableCell> */}
                                    <TableCell align="right" className="payments-table-headers">
                                        {Number(loan?.loanpayments?.amountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell align="right" className="payments-table-headers">
                                        {Number(loan?.loanpayments?.latefeesamountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell align="right" className="payments-table-headers">
                                        {Number(loan?.loanpayments?.principleamountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell align="right" className="payments-table-headers">
                                        {Number(loan?.loanpayments?.residualamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton onClick={(e) => handleMenuOpen(e, loan)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )) : (
                                <TableRow>
                                    <TableCell align="center" colSpan={9}>
                                        <Typography variant="body1" color="textSecondary">
                                            No data available
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={userPayments?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                    <MenuItem
                        disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                        onClick={() => {
                            handlePaymentBreakdown();
                            handleMenuClose();
                        }}
                    >
                        Payment Details
                    </MenuItem>
                    <MenuItem
                        disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                        onClick={() => {
                            handleViewDetails(selectedLoan)
                            handleMenuClose();
                        }}
                    >
                        View Details
                    </MenuItem>
                </Menu>
            </Box>

            <BaseDrawer
                open={openLoanDetailsDrawer}
                handleClose={() => setOpenLoanDetailsDrawer(false)}
                height="85vh"
            >
                <LoanPaymentDetails paymentId={selectedLoan?.loanpayments?.paymentid} />
            </BaseDrawer>

            <CustomAlert
                severity={alert.severity}
                show={alert.showAlert}
                header={alert.header}
                message={alert.message}
                onClick={() => {
                setAlert({ ...alert, showAlert: false });
                }}
                alertType={alert.alertType}
                confirmButton={alert.onConfirm}
                autoclose={alert.severity === "error" ? false : true}
            />

            <div className="loans-details-info-drawer">
                <BaseDrawer
                    open={openDetailsDrawer}
                    handleClose={() => setOpenDetailsDrawer(false)}
                    height="85vh"
                    className="loanProductInfoDrawer"
                    overflow="auto"
                >
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                    {/* Left Column - General Info */}
                                    <Box minWidth="300px" flex={1}>
                                        <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#6b7280',
                                            fontFamily: 'Nunito',
                                            fontSize: '16px',
                                        }}
                                        >
                                        General Info
                                        </Typography>

                                        {[
                                            { label: 'Payment ID', value: selectedLoan?.loanpayments?.paymentid },
                                            { label: 'User ID', value: selectedLoan?.loanpayments?.userid },
                                            { label: 'Loan ID', value: selectedLoan?.loanpayments?.loanid },
                                            { label: 'Payment Date', value: selectedLoan?.loanpayments?.paymentdate },
                                            { label: 'Currency', value: selectedLoan?.loanpayments?.currcode },
                                            { label: 'External Ref No', value: selectedLoan?.loanpayments?.externalrefno },
                                            { label: 'Lock Flag', value: selectedLoan?.loanpayments?.lockflag },
                                            { label: 'Late Fees Only', value: selectedLoan?.loanpayments?.latefeesonly === '1' ? 'Yes' : 'No' },
                                            { label: 'Error Message', value: selectedLoan?.loanpayments?.errormsg || 'None' },
                                        ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index} sx={{ display: 'flex', mb: 1 }}>
                                            <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                            {label}:
                                            </Box>
                                            <Box className="info-response" sx={{ width: '50%' }}>
                                            {value}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column - Payment Breakdown */}
                                    <Box minWidth="300px" flex={1}>
                                        <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#6b7280',
                                            fontFamily: 'Nunito',
                                            fontSize: '16px',
                                        }}
                                        >
                                        Payment Breakdown
                                        </Typography>

                                        {[
                                        { label: 'Payment Amount', value: formatAmount(selectedLoan?.loanpayments?.paymentamount) },
                                        { label: 'Amount Applied', value: formatAmount(selectedLoan?.loanpayments?.amountapplied) },
                                        { label: 'Residual Amount', value: formatAmount(selectedLoan?.loanpayments?.residualamount) },
                                        { label: 'Principal Applied', value: formatAmount(selectedLoan?.loanpayments?.principleamountapplied) },
                                        { label: 'Fees Applied', value: formatAmount(selectedLoan?.loanpayments?.feesamountapplied) },
                                        { label: 'Late Fees Applied', value: formatAmount(selectedLoan?.loanpayments?.latefeesamountapplied) },
                                        { label: 'Last Reconcile Date', value: selectedLoan?.loanpayments?.lastreconciledate || 'N/A' },
                                        ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index} sx={{ display: 'flex', mb: 1 }}>
                                            <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                            {label}:
                                            </Box>
                                            <Box className="info-response" sx={{ width: '50%' }}>
                                            {value}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </BaseDrawer>
            </div>

            {/* View Details Modal/Dialog */}
            <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Payment Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                    {/* Left Column - General Info */}
                                    <Box minWidth="300px" flex={1}>
                                        <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#6b7280',
                                            fontFamily: 'Nunito',
                                            fontSize: '16px',
                                        }}
                                        >
                                        General Info
                                        </Typography>

                                        {[
                                        { label: 'Payment ID', value: selectedLoan?.loanpayments?.paymentid },
                                        { label: 'User ID', value: selectedLoan?.loanpayments?.userid },
                                        { label: 'Loan ID', value: selectedLoan?.loanpayments?.loanid },
                                        { label: 'Payment Date', value: selectedLoan?.loanpayments?.paymentdate },
                                        { label: 'Currency', value: selectedLoan?.loanpayments?.currcode },
                                        { label: 'External Ref No', value: selectedLoan?.loanpayments?.externalrefno },
                                        { label: 'Lock Flag', value: selectedLoan?.loanpayments?.lockflag },
                                        { label: 'Late Fees Only', value: selectedLoan?.loanpayments?.latefeesonly === '1' ? 'Yes' : 'No' },
                                        { label: 'Error Message', value: selectedLoan?.loanpayments?.errormsg || 'None' },
                                        ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index} sx={{ display: 'flex', mb: 1 }}>
                                            <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                            {label}:
                                            </Box>
                                            <Box className="info-response" sx={{ width: '50%' }}>
                                            {value}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column - Payment Breakdown */}
                                    <Box minWidth="300px" flex={1}>
                                        <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#6b7280',
                                            fontFamily: 'Nunito',
                                            fontSize: '16px',
                                        }}
                                        >
                                        Payment Breakdown
                                        </Typography>

                                        {[
                                        { label: 'Payment Amount', value: formatAmount(selectedLoan?.loanpayments?.paymentamount) },
                                        { label: 'Amount Applied', value: formatAmount(selectedLoan?.loanpayments?.amountapplied) },
                                        { label: 'Residual Amount', value: formatAmount(selectedLoan?.loanpayments?.residualamount) },
                                        { label: 'Principal Applied', value: formatAmount(selectedLoan?.loanpayments?.principleamountapplied) },
                                        { label: 'Fees Applied', value: formatAmount(selectedLoan?.loanpayments?.feesamountapplied) },
                                        { label: 'Late Fees Applied', value: formatAmount(selectedLoan?.loanpayments?.latefeesamountapplied) },
                                        { label: 'Last Reconcile Date', value: selectedLoan?.loanpayments?.lastreconciledate || 'N/A' },
                                        ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index} sx={{ display: 'flex', mb: 1 }}>
                                            <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                            {label}:
                                            </Box>
                                            <Box className="info-response" sx={{ width: '50%' }}>
                                            {value}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default LoanPaymentView;